import { useEffect, useState } from "react";
import {
  createLabelQuery,
  getAllLabelsQuery,
  removeLabelQuery,
  updateLabelQuery
} from "@query";
import { LabelGroups, MAX_PROJECT_TYPE_LENGTH } from "@utils";
import { LabelEditor } from "@components";
import { Grid, CircularProgress } from "@material-ui/core";

export const ProjectTypes = () => {

  const [isLoading, setLoading] = useState(true);
  const [projectTypes, setProjectTypes] = useState([]);

  useEffect(() => {
    (async () => {
      let t = await getAllLabelsQuery(LabelGroups.PROJECT_TYPES);
      setProjectTypes(t);
      setLoading(false);
    })();
  }, []);
  
  const handleCreate = async (name, color, font) => {
    return await createLabelQuery(name, color, font, LabelGroups.PROJECT_TYPES)
  }
  
  const handleRemove = async (id) => {
    await removeLabelQuery(id);
  }
  
  const handleUpdate = async (id, name, color, font) => {
    await updateLabelQuery(id, name, color, font);
  }

  if(isLoading)
    return <Grid
      item container
      alignItems="center"
      justifyContent="center"
    >
      <CircularProgress size={24} />
    </Grid>

  return (
    <LabelEditor
      labelList={projectTypes}
      onCreate={handleCreate}
      onRemove={handleRemove}
      onUpdate={handleUpdate}
      maxLength={MAX_PROJECT_TYPE_LENGTH}
    />
  );
};